import sanityClient from '@sanity/client';

export default sanityClient({
    projectId: "otzvjb0c",
    dataset: "production"
})